type DetailedConciseSliderProps = {
  value: string | number;
  onValueChange: (value: number) => void;
  leftLabel?: string;
  rightLabel?: string;
  showExample?: boolean;
  exampleText?: string;
};

const ConcisenessSliderView = ({
  value,
  onValueChange,
  leftLabel = "Detailed",
  rightLabel = "Concise",
  showExample = false,
  exampleText = "",
}: DetailedConciseSliderProps) => {
  const slider = (
    <div className="flex items-center justify-between gap-4">
      <span className="text-sm text-muted-foreground">{leftLabel}</span>
      <input
        id="conciseness"
        type="range"
        min="0"
        max="100"
        step="1"
        value={value}
        onChange={(e) => onValueChange(Number(e.target.value))}
        className="h-2 w-full cursor-pointer appearance-none rounded-lg bg-border accent-primary"
      />
      <span className="text-sm text-muted-foreground">{rightLabel}</span>
    </div>
  );

  if (!showExample) return <div>{slider}</div>;

  return (
    <div className="grid grid-cols-2 gap-8">
      {slider}
      <div className="rounded-lg bg-surface-subtle p-4">
        <h4 className="mb-2 text-sm font-medium text-muted-foreground">Example Detail</h4>
        <p className="text-sm text-muted-foreground">{exampleText}</p>
      </div>
    </div>
  );
};

export default ConcisenessSliderView;
